import { Row } from "antd";
import { useMemo } from "react";
import { NameFormItem } from "./NameFormItem";
import { useCustomersIndividualFormRules } from "../../../../../../lib/hooks/useCustomersIndividualFormRules";
import { useCompanyNameRules } from "../../../../../../lib/hooks/useCompanyNameRules";

type FullNameFormItemsProps = {
  isIndividual: boolean;
};

export const FullNameFormItems = ({ isIndividual }: FullNameFormItemsProps) => {
  const { formOptions } = useCustomersIndividualFormRules(true);

  const path: string = useMemo(() => {
    return isIndividual ? "customerIndividualData" : "customerCompanyData";
  }, [isIndividual]);

  const { rules } = useCompanyNameRules();

  return (
    <>
      {isIndividual ? (
        formOptions.map((item: any, i: number) => (
          <Row className="mb-4" key={i}>
            <NameFormItem
              path={path}
              name={item.name}
              label={item.label}
              rules={item.rules}
            />
          </Row>
        ))
      ) : (
        <Row className="mb-4">
          <NameFormItem
            path={path}
            name="companyName"
            label="Company Name"
            rules={rules}
          />
        </Row>
      )}
    </>
  );
};
